import { createApp } from 'vue';
import './assets/styles/main.scss';
import App from './App.vue';

createApp(App).mount('#app');
